/**
 * A component that displays Progress br across the application based on the route and sectionName.
 *
 * @param {string} sectionName - The name of the section.
 * @param {string} section - For handling various conditions within the section.
 */
import React from 'react';
import { Autocomplete, FormHelperText, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import CountryFlagsComponent from '../../CountryFlagsComponent';
import { getCountryCode } from '../../../utils/helpers';

export const FXCMAutoCompleted = ( props ) =>{
    const {
        cssStyles,
        countryList,
        onOptionChange,
        selCountry,
        renderDropdownList,
        direction,
        label,
        textFieldSize,
        error,
        displayError,
        errorMessage

    } = props
    const { t: getLabel, i18n} = useTranslation();

  return (
    <div>
        <Autocomplete
            className={cssStyles}
            key={i18n?.language}
            id='country-select-demo'
            options={countryList}
            getOptionLabel={option => getLabel(option.country_desc)}
            onChange={(event, newValue) => onOptionChange(newValue)}
            value={selCountry}
            slotProps={{
                clearIndicator: {
                    id: "country-clear-btn"
                },
                popupIndicator: {
                    id: "country-open-btn"
                },
            }}
            renderOption={(props, option) => (
                <div>{renderDropdownList(props, option)}</div>
            )}
            renderInput={params => (
                <>
                {params.inputProps.value && (
                    <span
                    className={direction.status ? 'country-flag-arabic' : 'country-flag'}
                    >
                    <CountryFlagsComponent 
                        class="input-flag" 
                        countryCode={getCountryCode(countryList, params.inputProps.value, getLabel)}
                    />
                    </span>
                )}
                <TextField
                    {...params}
                    sx={{
                    '.MuiInputBase-root': {
                        '&::before': {
                        background: !params.inputProps.value
                            ? `url(${
                                process.env.REACT_APP_CDN_URL + '/images/search-icon.svg'
                            })`
                            : ''
                        }
                    }
                    }}
                    label={label}
                    inputProps={{
                    ...params.inputProps
                    }}
                    size={textFieldSize}
                        error={error}
                        className={errorMessage === "traduRedirect" ? "success-helper" : ""}
                    helperText={
                        error ? (
                            <FormHelperText id={`signup-country-error-${errorMessage}`}>{displayError()}
                            </FormHelperText>) : ''
                    }
                />
                </>
            )}
        />

    </div>
  )
}
FXCMAutoCompleted.propTypes = {
  cssStyles: PropTypes.string,
  countryList: PropTypes.string,
  onOptionChange: PropTypes.string,
  selCountry: PropTypes.string,
  renderDropdownList: PropTypes.string,
  direction: PropTypes.string,
  countryToFlag: PropTypes.string,
  label: PropTypes.string,
  textFieldSize: PropTypes.string,
  error: PropTypes.string,
  displayError: PropTypes.string,
}
